// extracted by mini-css-extract-plugin
export default {"button":"Pagination_button__gFE16","root":"Pagination_root__3MiIM","isActive":"Pagination_isActive__IHitl"};